<template>
  <div class="taskContainer">
    <div class="zhezhao" v-if="loading">
      <img :src="barstask" alt="" />
    </div>
    <div class="taskTitle">任务详情</div>
    <div class="taskInfo">
      <div class="part">
        <div class="imgContent">
          <img :src="bjtask" alt="" />
        </div>
        <div class="taskName">{{ taskInfo.taskName }}</div>
        <div class="timeInfo">
          <span>发布时间：{{ taskInfo.releasedAt }}</span>
          <span>截止日期：{{
            taskInfo.taskType == 0 ? taskInfo.endTime : "长期"
          }}</span>
        </div>
        <div class="tags" v-if="taskInfo.industryList">
          <span v-for="(item, y) in taskInfo.industryList" :key="y">
            {{ item.industryName }}
          </span>
        </div>
      </div>
      <div class="part">
        <div class="itemsTitle">
          <span class="line"></span><span>任务需求方</span>
        </div>
        <div class="partADetailInfo">
          <div class="profileAndName">
            <div class="profile">
              <img :src="header" alt="">
            </div>
            <div class="name" v-if="taskInfo.companyInfoDTO">
              {{ taskInfo.companyInfoDTO.companyName }}
            </div>
          </div>
        </div>
        <div class="description">
          <div class="desc">
            <p>真实发布单位</p>
            <p>发布者已通过企业认证</p>
          </div>
          <div class="truly">
            <img src="https://gsb-zc.oss-cn-beijing.aliyuncs.com//zc_44501578881852970202013101732970zhenshigao.png"
              alt="" />
            <p>真实度高</p>
          </div>
        </div>
      </div>
      <div class="part detailInfo">
        <div class="itemsTitle">
          <span class="line"></span><span>岗位详情</span>
        </div>
        <div class="detailContent">
          <!-- <div class="taskInfoItems">
            <div class="taskInfoDesc">底薪：</div>
            <div class="taskInfoDetail red">2500/月</div>
          </div> -->
          <div class="taskInfoItems">
            <div class="taskInfoDesc">服务费：</div>
            <div class="taskInfoDetail">
              <span v-if="taskInfo.salaryAsk == 'SECTION'">
                {{ taskInfo.salaryBlockMin }}-{{ taskInfo.salaryBlockMax }}元 /
                {{ taskInfo.salaryUnit }}
              </span>
              <span v-if="taskInfo.salaryAsk == 'DISCUSS'"> 面议 </span>
              <span v-if="!taskInfo.salaryAsk || taskInfo.salaryAsk == 'FIXED'">
                  {{ taskInfo.salarySettlement }}元/{{ taskInfo.salaryUnit }}
              </span>
            </div>
          </div>
          <div class="taskInfoItems">
            <div class="taskInfoDesc">招聘人数：</div>
            <div class="taskInfoDetail">
                {{
                  taskInfo.peopleNumber == -1
                  ? "人数不限"
                  : taskInfo.peopleNumber + "人"
                }}
            </div>
          </div>
          <div class="taskInfoItems">
            <div class="taskInfoDesc">年龄要求：</div>
            <div class="taskInfoDetail">
              {{ taskInfo.requirementAgeMin }}-{{ taskInfo.requirementAgeMax }}
            </div>
          </div>
          <div class="taskInfoItems">
            <div class="taskInfoDesc">任务地点：</div>
            <div class="taskInfoDetail" v-for="(item, y) in taskInfo.cityList" :key="y">
              {{ item.areaNamePath }}
            </div>
          </div>
          <div class="taskInfoItems">
            <div class="taskInfoDesc">工作时间：</div>
            <div class="taskInfoDetail">
              {{ taskInfo.workTimeBeginStr }}--{{ taskInfo.workTimeEndStr }}
            </div>
          </div>
          <div class="taskInfoItems">
            <div class="taskInfoDesc">性别要求：</div>
            <div class="taskInfoDetail">
              {{ genderMap[taskInfo.requirementSex] }}
            </div>
          </div>
          <div class="taskInfoItems">
            <div class="taskInfoDesc">学历要求：</div>
            <div class="taskInfoDetail">
              {{ eduMap[taskInfo.requirementEducation] }}
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="part">
        <div class="itemsTitle">
          <span class="line"></span><span>备注</span>
        </div>
        <div class="remarksContent">联系我时，请注明是在薪必果上看到的</div>
      </div> -->
      <!-- 协议展示 -->
      <div class="part" style="text-align: left; padding-left: 10px;">
        <div class="itemsTitle">
          <span class="line"></span><span>协议</span>
        </div>

        <div class="arguments" style="display: inline-block;" @click="showArgument">
          <nut-checkbox v-model="agreeArgument" icon-size="1em" label-disabled class="my-checkbox"
            shape="square"></nut-checkbox>
          <span style="vertical-align: middle">
            阅读并同意 <a>《自由职业者服务框架协议》</a>
          </span>
        </div>
        <div class="arguments" style="display: inline-block;" v-for="(item, index) in agreementList" :key="index"
          @click="chooseAgreement(index)">
          <nut-checkbox v-model="item.choose" icon-size="1em" label-disabled class="my-checkbox"
            shape="square"></nut-checkbox>
          <span style="vertical-align: middle">
            阅读并同意 <a>《{{ item.agreementName }}》</a>
          </span>
        </div>
      </div>
    </div>

    <div class="operationContainer">
      <van-button type="info" class="order-receiving" @click="checkUserStatus()">我要接单</van-button>
    </div>
    <!-- 弹出层 -->
    <van-popup v-model="typeShow">
      <div class="typeShow">
        <p>您尚未实名认证，请点击下方按钮完成实名认证</p>
        <div class="type-father">
          <div class="type-but" @click="toShiming">去实名</div>
          <div class="type-but" style="margin-left:30px;background: #ffffff;border:1px solid #0681FD;color: #0681FD;"
            @click="closeShow">取消</div>
        </div>
      </div>
    </van-popup>

    <!-- 协议弹框 -->
    <nut-dialog title="自由职业者服务框架协议" :visible="agreementInfo" @ok-btn-click="agreementSure" okBtnTxt="我同意"
      @cancel-btn-click="agreementInfo = false" @close="agreementInfo = false">
      <RegisterAgreementDetail></RegisterAgreementDetail>
    </nut-dialog>
    <!-- 自定义协议 -->
    <nut-dialog :title="agreementItem.agreementName" :visible="agreementDialog" @ok-btn-click="agreementAgree"
      okBtnTxt="我同意" @cancel-btn-click="agreementDialog = false" @close="agreementDialog = false">
      <div v-html="agreementItem.content"></div>
    </nut-dialog>
  </div>
</template>
<script>
import RegisterAgreementDetail from "../../agreement/RegisterAgreementDetail.vue";
import http from "../../../api/index.js";
import config from "../../../utils/config";
import dayjs from 'dayjs';
export default {
  components: {
    RegisterAgreementDetail
  },
  data() {
    return {
      agreeArgument: false,
      agreementInfo: false,
      agreementList: [],
      agreementItem: {},
      showAgreementIndex: 0,
      agreementDialog: false,
      loading: false,
      formData: {
        // companyTaskNo:"10377162432963639624930",
        platformTaskNo: "",
      },
      typeShow: false,
      barstask: require("../../../assets/img/barstask.svg"),
      bjtask: require("../../../assets/img/bjtask.png"),
      header: require("../../../assets/img/real/touxiang.png"),
      formApply: {
        taskNo: "",
        // taskNo:"40161113151407857363",
        // taskNo:"10344162053924503790576",

      },
      taskInfo: {},
      operationShow: true,//接单
      eduMap: {
        10: "学历不限",
        20: "初中",
        30: "高中",
        40: "专科",
        50: "本科",
        60: "硕士",
        70: "博士"
      },
      genderMap: {
        male: "男",
        female: "女",
        unlimited: "不限"
      },
      taskNo: "",
    }
  },
  mounted() {
    const url = new URL(location.href);
    // this.formData.platformTaskNo = url.searchParams.get('taskNo');
    this.formData.platformTaskNo = sessionStorage.getItem("taskNo");
    this.formApply.taskNo = sessionStorage.getItem("taskNo");
    this.fetchTaskDetail();
    // this.checkUserStatus();
    this.loadAgreements();
  },
  methods: {
    showArgument() {
      if (this.agreeArgument == true) {
        this.agreeArgument = false;
      } else {
        this.agreementInfo = true;
      }
    },
    chooseAgreement(index) {
      const item = this.agreementList[index];
      if (item.choose == true) {
        item.choose = false;
        this.agreementList.splice(index, 1, item);
      } else {
        this.agreementItem = item;
        this.showAgreementIndex = index;
        this.agreementDialog = true;
      }
    },
    agreementSure() {
      this.agreeArgument = true;
      this.agreementInfo = false;
    },
    agreementAgree() {
      var par = {
        agreementId: this.agreementItem.id,
        agreementType: this.agreementItem.agreementType || "",
        platformTaskNo: this.taskInfo.platformTaskNo,
        systemModel: "bpo-app-h5",
      };
      http.post(config.agreementAgree, par).then((res) => {
        // 没有 loginkey 接口不通
        this.agreementItem.choose = true;
        this.agreementList.splice(
          this.showAgreementIndex,
          1,
          this.agreementItem
        );
        this.agreementDialog = false;
        if (res.code == 0) {
          // this.agreementItem.choose = true;
          // this.agreementList.splice(
          //   this.showAgreementIndex,
          //   1,
          //   this.agreementItem
          // );
          // this.agreementDialog = false;
        } else {
          // this.$toast.fail(res.message);
        }
      });
    },
    loadAgreements() {
      http.post(config.agreementQuery, { platformTaskNo: this.formData.platformTaskNo })
        .then((res) => {
          if (res.code == 0) {
            res.data.map((item) => {
              item.choose = false;
            });
            this.agreementList = res.data;
          } else {
            this.$toast.fail(res.message);
          }
        });
    },

    fetchTaskDetail() {
      http.post(config.platformDetail, this.formData).then(({ code, data, message }) => {
        if (code === 0) {
          this.taskInfo = data;
          data.workTimeBeginStr = data.workTimeBegin ? dayjs(data.workTimeBegin).format("YYYY-MM-DD") : ''
          data.workTimeEndStr = data.workTimeEnd ? dayjs(data.workTimeEnd).format("YYYY-MM-DD") : ''
        } else {
          this.$toast.fail(message)
        }
      })
    },
    closeShow() {
      this.typeShow = false;
    },
    applyH5() {
      this.formApply.redirectDomain = config.topDomainName;
      http.post(config.applyH5, this.formApply).then(({ code, data, message }) => {
        if (code === 0) {
          if (data.applyResult === 2) {
            // 跳转到signUrl
            location.href = data.signUrl
          } else { // 【0 或 1 的情况】
            if (data.thirdRedirectUrl) {
              // 跳转到第三方页面
              location.href = data.thirdRedirectUrl
            } else {
              //  返回到申请成功页面
              this.$router.push({ path: "/applicationSuccess" })
            }
          }
        } else {
          this.$toast.fail(message)
        }
      })
    },
    checkUserStatus() {
      if (!this.agreeArgument) {
        this.$toast.fail('请勾选协议')
        return
      }
      for (var i = 0; i < this.agreementList.length; i++) {
        var item = this.agreementList[i];
        if (item.choose == false) {
          this.loading = false;
          this.$toast.fail(`请阅读并同意《${item.agreementName}》`);
          this.agreementItem = item;
          this.showAgreementIndex = i;
          this.agreementDialog = true;
          return;
        }
      }

      http.post(config.h5UserHomeInfo).then(({ code, data, message }) => {
        if (code === 0) {
          if (data.code === 200) {
            this.applyH5()
            // this.operationShow=true;
          } else {
            this.typeShow = true;
          }
        } else {
          this.$toast.fail(message)
        }

      })
    },
    toShiming() {
      this.$router.push({ path: "../register" })
    }
  }
}
</script>

<style lang="less" scoped>
.taskContainer {
  position: relative;
  width: 100%;
  height: 100%;
  text-align: left;

  .zhezhao {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    z-index: 9999;
    display: inline-block;
    background: rgba(0, 0, 0, 0.4);

    img {
      width: 54px;
      height: 56px;
      display: block;
      margin: 76% auto;
    }
  }

  .taskTitle {
    width: 100%;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5em;
    color: #333;
    text-align: center;
    font-weight: 500;
    border-bottom: 1px solid #f3f4f6;
  }

  .taskInfo {
    width: 100%;
    height: 80%;
    overflow-x: hidden;
    overflow-y: auto;
    background: #efefef;

    .part {
      background: #fff;
      padding: 4%;
      margin-bottom: 2%;

      .arguments {
        color: #a2a2a2;
        font-size: 1.08em;
        margin-top: 3vh;
        text-align: center;

        a {
          color: #3083ff;
        }
      }

      .itemsTitle {
        display: flex;
        align-items: center;
        align-content: center;

        //margin-bottom: 1em;
        span {
          font-size: 1.25em;
          font-weight: bold;

          &.line {
            display: inline-block;
            height: 1em;
            width: 2px;
            background: #1890ff;
            margin-right: 2%;
          }
        }
      }

      .imgContent {
        img {
          width: 100%;
          height: auto;
        }
      }

      .taskName {
        margin-top: 0.8em;
        font-size: 1.25em;
        color: #333;
        font-weight: bold;
        text-align: left;
      }

      .timeInfo {
        display: flex;
        justify-content: space-between;
        color: #666;
        margin-top: 0.8em;
      }

      .tags {
        margin-top: 0.8em;
        text-align: left;

        span {
          display: inline-block;
          margin-bottom: 0.3em;
          background: #f0f8ff;
          color: #0681fd;
          padding: 0.3em 0.4em;
          margin-right: 0.4em;
        }
      }

      .partADetailInfo {
        width: 100%;
        height: 40%;
        padding-top: 2%;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content: space-between;

        .profileAndName {
          width: 88%;
          display: flex;
          align-content: center;
          align-items: center;

          .profile {
            display: flex;
            align-items: center;
            align-content: center;
            justify-content: center;
            font-size: 1em;
            width: 4vh;
            height: 4vh;
            color: #1890ff;
            margin-right: 10px;

            img {
              width: 50px;
              height: auto;
            }
          }

          .name {
            font-size: 1.15em;
          }
        }
      }

      .description {
        height: 50%;
        background: #f0f8ff;
        border-radius: 10px;
        display: flex;
        justify-content: space-between;
        align-content: center;
        align-items: center;
        margin-top: 1%;
        padding: 2% 3%;

        .desc {
          height: 100%;
          display: flex;
          justify-content: center;
          flex-direction: column;

          p:first-child {
            font-size: 1.2em;
            font-weight: 500;
            color: #333333;
          }

          p:last-child {
            margin-top: 1vh;
            font-size: 1.15em;
            color: #666666;
          }
        }

        .truly {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;

          img {
            width: 40px;
            height: 40px;
            margin: 0 auto;
          }

          p {
            margin-top: 1vh;
            font-size: 1.15em;
            font-weight: bold;
            color: #0681fd;
          }

          i {
            text-align: center;
            color: #0681fd;
            font-size: 1.8em;
            font-weight: bold;
          }
        }
      }

      .remarksContent {
        font-size: 1.15em;
        padding: 1em 0;
        line-height: 1.8em;
        color: #666;
      }

      .detailContent {
        display: flex;
        flex-direction: column;

        .taskInfoItems {
          margin-bottom: 0.8em;
          display: flex;
          font-size: 1.15em;

          &:last-child {
            margin-bottom: 0;
          }

          &:first-child {
            margin-top: 1.2em;
          }

          .taskInfoDesc {
            color: #666;
          }

          .taskInfoDetail {
            color: #c4c4c4;

            &.red {
              color: #f00;
            }
          }
        }
      }
    }
  }

  .operationContainer {
    // width: 100%;
    height: 10%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 4%;

    .order-receiving {
      width: 100%;
      height: 100px;
      border-radius: 45px;
    }
  }

  .typeShow {
    height: 220px;
    padding: 10px;

    box-sizing: border-box;
    text-align: center;

    .type-father {
      display: flex;
      justify-content: center;
      width: 100%;
      margin-top: 45px;

      .type-but {
        width: 140px;
        height: 60px;
        background: #0681FD;
        border-radius: 45px;
        color: #ffffff;
        line-height: 60px;
      }
    }
  }
}
</style>
<style>
.taskContainer .nut-button.block {
  background: #21aaff;
}

.taskContainer .nut-button[disabled] {
  cursor: not-allowed;
  background: #dadada;
  color: #f6f6f6;

}

.taskContainer .van-popup--center {
  width: 80%;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/task/taskDetail/index.vue